<template>
  <BaseViewComponent
    name="headlines"
    :is-preview="isPreview"
  >
    <div class="headlines-wrapper full-width text-center">
      <div class="container">
        <div class="text">
          <div class="title-h4">
            {{ pageData.headlinesSubtitle }}
          </div>
          <div class="title-h2">
            {{ pageData.headlinesTitle }}
          </div>
          <div class="text-p">
            {{ pageData.headlinesDescription }}
          </div>
        </div>
      </div>
    </div>
  </BaseViewComponent>
</template>

<script setup>
import BaseViewComponent from 'components/book-landing/render/BaseViewComponent.vue';
import { useBookPageStore } from 'stores/bookPage';
import { storeToRefs } from 'pinia';

defineProps({
  isPreview: {
    type: Boolean,
    default: false,
  },
});

const bookPageStore = useBookPageStore();
const { pageData } = storeToRefs(bookPageStore);
</script>
